import React from "react";
import { Link } from "react-router-dom";
import "./AppearanceHandle.css";

/**
 * Appearance Engine handle / username (@slug).
 * Colors come from --handle-* tokens — never page-specific hardcodes.
 */
function AppearanceHandle({
  handle,
  to,
  href,
  truncate = false,
  block = false,
  className = "",
  prefix = "@",
  as: asProp,
  ...rest
}) {
  const cleaned = String(handle || "").replace(/^@/, "").trim();
  if (!cleaned) {
    return null;
  }

  const classes = [
    "ae-handle",
    truncate ? "ae-handle--truncate" : "",
    block ? "ae-handle--block" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const label = `${prefix}${cleaned}`;

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {label}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        {label}
      </a>
    );
  }

  const Tag = asProp || "span";
  return (
    <Tag className={classes} {...rest}>
      {label}
    </Tag>
  );
}

export default AppearanceHandle;
